var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileTwoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 44.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-icon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    d: "M22.35,10.67a6.73,6.73,0,1,1-6.73,6.73A6.73,6.73,0,0,1,22.35,10.67Zm0,10.46a3.73,3.73,0,1,0-3.73-3.73A3.73,3.73,0,0,0,22.35,21.13Z",
    transform: "translate(-0.01 0)",
    fill: "#5ce706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M30.48,35.15a1.5,1.5,0,0,1-1.5-1.5V31.23a2.37,2.37,0,0,0-2.35-2.35H18.15a2.35,2.35,0,0,0-2.35,2.35v2.42a1.5,1.5,0,0,1-3,0V31.23a5.36,5.36,0,0,1,5.35-5.35h8.48A5.37,5.37,0,0,1,32,31.23v2.42A1.5,1.5,0,0,1,30.48,35.15Z",
    transform: "translate(-0.01 0)",
    fill: "#5ce706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    d: "M22.5,0a22.44,22.44,0,1,1-8.76,1.77A22.49,22.49,0,0,1,22.5,0Zm0,42a19.49,19.49,0,1,0-7.59-1.53A19.51,19.51,0,0,0,22.5,42Z",
    transform: "translate(-0.01 0)",
    fill: "#243747"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTwoIcon);
export default __webpack_public_path__ + "static/media/profile_two_icon.56e016ff3b103a54c0a022f0683c4587.svg";
export { ForwardRef as ReactComponent };